import React from "react";
import styled from "styled-components";
// @ts-ignore
import BackgroundImage from "../../assets/images/bg.svg";
import {convertSvgToBase64Url, hexToRgbA} from "../../services/app";
import {useApp} from "../../contexts/app";

export const Container = styled.div`
  background-color: ${props => props.theme.main || "#40A68C"};
  height: 100%;
`
export const ContainerImage = (props: any) => {
    const {themeColors} = useApp();

    return (
        <Container {...props} style={!themeColors?.main ? {
            ...(props.style || {}),
            backgroundImage: `url(${BgImage(themeColors)})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundColor: themeColors?.main || "#40A68C",
            minHeight: '100%'
        } : {
            ...(props.style || {}),
            backgroundColor: hexToRgbA(themeColors?.main, 0.2),
            minHeight: '100%'
        }}>{props.children}</Container>
    )
}
export const ContainerView = styled.div`
  background: #FFFFFF;
  border-radius: 16px 16px 0 0;
  padding: 16px;
  padding-bottom: 80px;
  min-height: calc(100% - 56px);
`
export const ContainerViewFooter = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  z-index: 1;
  padding: 9px 16px 20px 16px;
  background-color: white;
`

export const BgImage = (themeColors: any) => {
    const mainColor = null;

    const image = `
    <svg width="414" height="896" viewBox="0 0 414 896" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2381_40606)">
                <rect width="414" height="896" fill="white"/>
                <rect width="414" height="896" fill="url(#paint0_linear_2381_40606)"/>
                <g filter="url(#filter0_dddd_2381_40606)">
                    <path d="M120.557 0L555 824L445 1314H-57L-426 824V0H120.557Z"
                          fill="url(#paint1_linear_2381_40606)"/>
                </g>
            </g>
            <defs>
                <filter id="filter0_dddd_2381_40606" x="-458" y="-8" width="1045" height="1378"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="0.5"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2381_40606"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="4"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                    <feBlend mode="normal" in2="effect1_dropShadow_2381_40606" result="effect2_dropShadow_2381_40606"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="16"/>
                    <feGaussianBlur stdDeviation="12"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                    <feBlend mode="normal" in2="effect2_dropShadow_2381_40606" result="effect3_dropShadow_2381_40606"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="24"/>
                    <feGaussianBlur stdDeviation="16"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                    <feBlend mode="normal" in2="effect3_dropShadow_2381_40606" result="effect4_dropShadow_2381_40606"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_2381_40606" result="shape"/>
                </filter>
                <linearGradient id="paint0_linear_2381_40606" x1="230" y1="55" x2="725.914" y2="305.027"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="${hexToRgbA(mainColor, 0.5) || "#39A086"}"/>
                    <stop offset="1" stop-color="${hexToRgbA(mainColor, 0.4) || "#80DDC8"}"/>
                </linearGradient>
                <linearGradient id="paint1_linear_2381_40606" x1="7.50002" y1="-8.92883e-06" x2="686.651" y2="882.476"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="${hexToRgbA(mainColor, 0.4) || "#39A086"}"/>
                    <stop offset="1" stop-color="${hexToRgbA(mainColor, 0.3) || "#80DDC8"}"/>
                </linearGradient>
                <clipPath id="clip0_2381_40606">
                    <rect width="414" height="896" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    `;
    return convertSvgToBase64Url(image);
}
